function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, memo, useEffect, useImperativeHandle, useState } from "react";
import { useMemoizedFn } from "ahooks";
import { withNativeProps } from "../../utils/with-native-props";
import classNames from "classnames";
import { defaultRenderLabel } from "./picker-utils";
import { mergeProps } from "../../utils/mergeProps";
import { usePropsValue } from "../../utils/use-props-value";
import { generateColumnsExtend, useColumnsExtends } from "../picker-view/columns-extend";
import PickerView from "../picker-view";
import Popup from "../popup";
import SafeArea from "../safe-area";
var classPrefix = "tc-picker";
var defaultProps = {
  defaultValue: [],
  closeOnMaskClick: true,
  renderLabel: defaultRenderLabel,
  destroyOnClose: false,
  forceRender: false
};
export var Picker = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (p, ref) {
  var _a;
  var props = mergeProps(defaultProps, {
    confirmText: "確認",
    cancelText: "取消"
  }, p);
  var _usePropsValue = usePropsValue({
      value: props.visible,
      defaultValue: false,
      onChange: function onChange(v) {
        var _a;
        if (v === false) {
          (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        }
      }
    }),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    visible = _usePropsValue2[0],
    setVisible = _usePropsValue2[1];
  var actions = {
    toggle: function toggle() {
      setVisible(function (v) {
        return !v;
      });
    },
    open: function open() {
      setVisible(true);
    },
    close: function close() {
      setVisible(false);
    }
  };
  useImperativeHandle(ref, function () {
    return actions;
  });
  var _usePropsValue3 = usePropsValue(Object.assign(Object.assign({}, props), {
      defaultValue: props.defaultValue,
      onChange: function onChange(val) {
        var _a;
        var extend = generateColumnsExtend(props.columns, val);
        (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props, val, extend);
      }
    })),
    _usePropsValue4 = _slicedToArray(_usePropsValue3, 2),
    value = _usePropsValue4[0],
    setValue = _usePropsValue4[1];
  var extend = useColumnsExtends(props.columns, value);
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  useEffect(function () {
    if (innerValue !== value) {
      setInnerValue(value);
    }
  }, [visible]);
  useEffect(function () {
    if (!visible) {
      setInnerValue(value);
    }
  }, [value]);
  var onChange = useMemoizedFn(function (val, ext) {
    var _a;
    setInnerValue(val);
    if (visible) {
      (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, val, ext);
    }
  });
  var pickerElement = withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-header")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-header-button ").concat(classPrefix, "-header-button--cancel"),
    onClick: function onClick() {
      var _a;
      (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
      setVisible(false);
    }
  }, props.cancelText), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-header-title")
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(classPrefix, "-header-button"), "".concat(classPrefix, "-header-button--confirm"), props.loading && "".concat(classPrefix, "-header-button-disabled")),
    onClick: function onClick() {
      if (props.loading) return;
      setValue(innerValue, true);
      setVisible(false);
    },
    "aria-disabled": props.loading
  }, props.confirmText)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-body")
  }, /*#__PURE__*/React.createElement(PickerView, {
    className: props.pickerViewClassName,
    style: props.pickerViewStyle,
    loading: props.loading,
    loadingContent: props.loadingContent,
    columns: props.columns,
    renderLabel: props.renderLabel,
    value: innerValue,
    mouseWheel: props.mouseWheel,
    onChange: onChange
  }))));
  var popupElement = /*#__PURE__*/React.createElement(Popup, {
    style: props.popupStyle,
    className: classNames("".concat(classPrefix, "-popup"), props.popupClassName),
    visible: visible,
    position: 'bottom',
    onMaskClick: function onMaskClick() {
      var _a;
      if (!props.closeOnMaskClick) return;
      (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
      setVisible(false);
    },
    getContainer: props.getContainer,
    destroyOnClose: props.destroyOnClose,
    afterShow: props.afterShow,
    afterClose: props.afterClose,
    onClick: props.onClick,
    forceRender: props.forceRender,
    stopPropagation: props.stopPropagation
  }, pickerElement, /*#__PURE__*/React.createElement(SafeArea, {
    position: 'bottom'
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, popupElement, (_a = props.children) === null || _a === void 0 ? void 0 : _a.call(props, extend.items, actions));
}));
Picker.defaultProps = defaultProps;
export default Picker;